<nz-tabset (nzSelectChange)="$event.index === 1 && onVaultTabActivated()">
  <nz-tab nzTitle="{{ 'dialog.fightLoad.localDrafts' | translate }}">
    <nz-spin nzTip="{{ 'system.loading' | translate }}" [nzSpinning]="loading">
      <div style="height: 360px">
        <div *ngIf="!loading && container.fights && container.fights.length > 0">
          <div style="height: 360px; overflow: auto" customScroll>
            <nz-list
              #fights
              [nzDataSource]="container.fights"
              [nzRenderItem]="item"
              nzSize="small"
              [ngClass]="{ loadList: true }"
            >
              <ng-template #item let-item>
                <nz-list-item [nzActions]="[removeAction]">
                  <nz-list-item-meta
                    [nzTitle]="nzTitle"
                    [nzDescription]="nzDescription"
                    (click)="select(item)"
                  >
                    <ng-template #nzTitle>
                      <span *ngIf="item.isDraft">{{
                        "dialog.fightLoad.draft" | translate
                      }}</span>
                      {{ item.name }}
                    </ng-template>
                    <ng-template #nzDescription>
                      <span *ngIf="!!item.dateCreated"
                        >{{ "dialog.fightLoad.created" | translate }}:
                        {{ item.dateCreated | date : "medium" }}</span
                      >
                      <span
                        *ngIf="
                          !!item.dateModified &&
                          (item.dateCreated | date : 'medium') !==
                            (item.dateModified | date : 'medium')
                        "
                      >
                        &nbsp;&nbsp;&nbsp;&nbsp;{{
                          "dialog.fightLoad.lastUpdate" | translate
                        }}: {{ item.dateModified | date : "medium" }}
                      </span>
                    </ng-template>
                  </nz-list-item-meta>
                  <ng-template #removeAction>
                    <span class="actions" #actionItem>
                      <a
                        nz-popconfirm
                        nzPopconfirmTitle="{{
                          'dialog.fightLoad.youSureDeleteFight' | translate
                        }}"
                        (nzPopconfirmVisibleChange)="
                          removevisiblechanged(actionItem, $event)
                        "
                        (nzOnConfirm)="remove(item)"
                      >
                        <i
                          nz-icon
                          nzType="delete"
                          class="action-icon"
                          nzTheme="twotone"
                        ></i>
                      </a>
                    </span>
                  </ng-template>
                </nz-list-item>
              </ng-template>
            </nz-list>
          </div>
        </div>
        <div
          *ngIf="!loading && (!container.fights || container.fights.length === 0)"
        >
          <nz-empty></nz-empty>
        </div>
      </div>
    </nz-spin>
  </nz-tab>

  <nz-tab nzTitle="{{ 'dialog.fightLoad.nostrVault' | translate }}">
    <div style="height: 360px">
      <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px">
        <nostr-status
          [relayStatus$]="nostrStatus.fetchStatus$"
          [progress$]="nostrStatus.consensusProgress$"
        ></nostr-status>
        <span *ngIf="vaultLoading">{{ "dialog.fightLoad.scanningRelays" | translate }}</span>
        <span style="flex: 1"></span>
        <button nz-button nzSize="small" (click)="refreshVault()" [nzLoading]="vaultLoading">
          <i nz-icon nzType="sync"></i>
        </button>
      </div>

      <div *ngIf="!vaultLoading && vaultPlans.length > 0" style="height: 300px; overflow: auto" customScroll>
        <nz-list [nzDataSource]="vaultPlans" [nzRenderItem]="vaultItem" nzSize="small">
          <ng-template #vaultItem let-item>
            <nz-list-item [nzActions]="[vaultRemoveAction]">
              <nz-list-item-meta
                [nzTitle]="vaultTitle"
                [nzDescription]="vaultDescription"
                (click)="selectVaultItem(item)"
              >
                <ng-template #vaultTitle>
                  <nz-tag *ngIf="item.visibility === 'private'" nzColor="default">{{
                    "dialog.fightLoad.private" | translate
                  }}</nz-tag>
                  {{ item.name }}
                </ng-template>
                <ng-template #vaultDescription>
                  {{ "dialog.fightLoad.published" | translate }}: {{ item.publishedAt | date : "medium" }}
                </ng-template>
              </nz-list-item-meta>
              <ng-template #vaultRemoveAction>
                <span class="actions" #vaultActionItem>
                  <a
                    nz-popconfirm
                    nzPopconfirmTitle="{{ 'dialog.fightLoad.youSureDeleteFight' | translate }}"
                    (nzPopconfirmVisibleChange)="removevisiblechanged(vaultActionItem, $event)"
                    (nzOnConfirm)="removeVaultItem(item)"
                  >
                    <i nz-icon nzType="delete" class="action-icon" nzTheme="twotone"></i>
                  </a>
                </span>
              </ng-template>
            </nz-list-item>
          </ng-template>
        </nz-list>
        <div *ngIf="vaultHasMore" style="text-align: center; padding: 8px">
          <button nz-button nzSize="small" (click)="loadMoreVault()">
            {{ "dialog.fightLoad.loadMore" | translate }}
          </button>
        </div>
      </div>

      <div *ngIf="!vaultLoading && vaultLoaded && vaultPlans.length === 0">
        <nz-empty [nzNotFoundContent]="'dialog.fightLoad.noVaultItems' | translate"></nz-empty>
      </div>
    </div>
  </nz-tab>
</nz-tabset>

<div *nzModalFooter>
  <button nz-button nzType="primary" (click)="onNoClick()" cdkFocusInitial>
    {{ "dialog.cancel" | translate }}
  </button>
</div>

<ng-template #headerTemplate>
  <div style="display: flex !important">
    <div class="ant-modal-title">
      <div class="ng-star-inserted">
        {{ "dialog.fightLoad.header" | translate }}
      </div>
    </div>
    <span class="example-spacer"></span>
    <nz-switch
      name="asdf"
      nzCheckedChildren="{{ 'dialog.fightLoad.showDraft' | translate }}"
      nzUnCheckedChildren="{{ 'dialog.fightLoad.doNotShowDraft' | translate }}"
      [ngModel]="false"
      #showDrafts
    ></nz-switch>
  </div>
</ng-template>
